import {Button} from "@zendeskgarden/react-buttons";
import {Field, Input, Label, Message, Textarea} from "@zendeskgarden/react-forms";
import {ReactElement} from "react";
import * as css from "../styles/narrativeEditor.module.scss";


interface NarrativeSectionEditorProps {
    title: string;
    body: string;
    titleError: string | null;
    isSaving: boolean;
    onTitleChange: (title: string) => void;
    onBodyChange: (body: string) => void;
    onCancel: () => void;
    onSave: () => void;
}

export default function NarrativeSectionEditor(props: NarrativeSectionEditorProps): ReactElement {
    return (
        <div className={css.sectionRowEditing}>
            <div className={css.sectionEditorTitleColumn}>
                <Field>
                    <Label>Title</Label>
                    <Input
                        className={css.sectionTitleInput}
                        isCompact
                        placeholder="Section title"
                        value={props.title}
                        validation={props.titleError ? "error" : undefined}
                        onChange={evt => props.onTitleChange(evt.target.value)}
                    />
                    {props.titleError &&
                        <Message validation="error">{props.titleError}</Message>
                    }
                </Field>
            </div>

            <div className={css.sectionEditorBodyColumn}>
                <Field>
                    <Label>Body</Label>
                    <Textarea
                        className={css.sectionBodyTextarea}
                        minRows={2}
                        autoFocus
                        value={props.body}
                        placeholder="Enter anything you would like to say about this Property and Budget..."
                        onChange={evt => props.onBodyChange(evt.target.value)}
                    />
                </Field>

                <div className={css.sectionEditorActions}>
                    <Button className={css.cancelButton} isBasic size="small" disabled={props.isSaving} onClick={props.onCancel}>
                        Cancel
                    </Button>
                    <Button isPrimary size="small" disabled={props.isSaving} onClick={props.onSave}>
                        Save
                    </Button>
                </div>
            </div>
        </div>
    );
}
